export default {"src":"/_next/static/media/GooglePay.5dfff064.svg","height":36,"width":53,"blurWidth":0,"blurHeight":0};